import Games from '@material-ui/icons/Games'
export const GamesIcon = Games
